<template>
  <basic-container>
    <div class="business-entity-container">
      <!-- 搜索区域 -->
      <div class="search-area">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="经营主体名称">
            <el-input v-model="searchForm.entityName" placeholder="请输入经营主体名称" clearable
              prefix-icon="el-icon-search"></el-input>
          </el-form-item>
          <el-form-item label="商户号">
            <el-input v-model="searchForm.subMerchant" placeholder="请输入商户号" clearable
              prefix-icon="el-icon-search"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button type="text" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作区域 -->
      <div class="action-area">
        <el-button type="text" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="text" icon="el-icon-delete" @click="handleBatchDelete" v-if="selectedIds.length > 0">
          批量删除 ({{ selectedIds.length }})
        </el-button>
      </div>
      <!-- 表格区域 -->
      <div class="table-area">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
          border>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="entityName" label="经营主体名称" min-width="200"></el-table-column>
          <el-table-column prop="subMerchant" label="商户号" min-width="180"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
          <el-table-column label="操作" width="450" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" icon="el-icon-edit" @click="handleBindShop(scope.row)">关联商户</el-button>
              <el-button type="text" icon="el-icon-edit" @click="handleBindOrderer(scope.row)">关联订单员</el-button>
              <el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <div class="pagination-area">
        <div class="pagination-info">
          共 {{ total }} 条
        </div>
        <el-pagination background layout="prev, pager, next, jumper, total" :total="total" :page-size="pagination.size"
          :current-page="pagination.page" @current-change="handleCurrentChange"
          @size-change="handleSizeChange"></el-pagination>
      </div>
      <!-- 新增/编辑对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false"
        class="business-entity-dialog">
        <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
          <el-form-item label="主体名称" prop="entityName">
            <el-input v-model="formData.entityName" placeholder="请输入经营主体名称" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="商户号" prop="subMerchant">
            <el-input v-model="formData.subMerchant" placeholder="请输入商户号" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="businessTypes">
            <el-select v-model="formData.businessTypes" multiple clearable placeholder="请选择业务类型（可多选，非必填）"
              style="width: 100%;">
              <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" icon="el-icon-close" @click="dialogVisible = false">取消</el-button>
          <el-button type="text" icon="el-icon-check" @click="handleSubmit">确定</el-button>
        </span>
      </el-dialog>
      <!-- 关联商户对话框 -->
      <el-dialog title="关联商户" :visible.sync="bindShopDialogVisible" width="800px" :close-on-click-modal="false">
        <div class="bind-shop-dialog-content">
          <!-- 已关联商户列表 -->
          <div class="already-bound-shops">
            <div class="shop-search-section">
              <h5>已关联商户</h5>
              <div class="search-box">
                <el-input v-model="boundShopSearchKey" placeholder="请输入商户名称" clearable prefix-icon="el-icon-search"
                  @keyup.enter.native="handleBoundShopSearch"></el-input>
                <el-button type="text" icon="el-icon-search" @click="handleBoundShopSearch">搜索</el-button>
                <el-button type="text" icon="el-icon-refresh" @click="resetBoundShopSearch">重置</el-button>
              </div>
            </div>
            <el-table v-if="filteredBoundShops && filteredBoundShops.length > 0" :data="filteredBoundShops" border
              style="width: 100%" size="small">
              <el-table-column prop="shopName" label="商户名称" min-width="200"></el-table-column>
              <el-table-column prop="shopMobile" label="电话号码" min-width="150"></el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-delete" @click="removeShopBinding(scope.row)">解除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="no-shops-tip">暂无关联商户</div>
            <!-- 已关联商户分页 -->
            <div v-if="boundShopTotal > 0" class="bound-shop-pagination-area">
              <div class="pagination-info">
                共 {{ boundShopTotal }} 条
              </div>
              <el-pagination background layout="prev, pager, next, jumper, total" :total="boundShopTotal"
                :page-size="boundShopPagination.size" :current-page="boundShopPagination.page"
                @current-change="handleBoundShopCurrentChange" @size-change="handleBoundShopSizeChange"></el-pagination>
            </div>
          </div>
          <!-- 添加商户按钮 -->
          <div class="add-shop-section">
            <el-button type="text" icon="el-icon-plus" @click="openShopDialog" class="add-shop-btn">添加关联商户</el-button>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" icon="el-icon-close" @click="bindShopDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <!-- 商户选择对话框 -->
      <el-dialog title="选择商户" :visible.sync="shopDialogVisible" width="700px" :close-on-click-modal="false">
        <div class="shop-dialog-content">
          <!-- 搜索区域 -->
          <div class="shop-search-area">
            <label>商户名称：</label>
            <el-input v-model="shopSearchForm.shopName" placeholder="请输入商户名称" clearable
              @keyup.enter.native="handleShopSearch"></el-input>
            <label>商户电话：</label>
            <el-input v-model="shopSearchForm.shopMobile" placeholder="请输入商户电话" clearable
              @keyup.enter.native="handleShopSearch"></el-input>
            <el-button type="text" icon="el-icon-search" @click="handleShopSearch">搜索</el-button>
            <el-button type="text" icon="el-icon-refresh" @click="resetShopSearch">重置</el-button>
          </div>
          <!-- 商户列表 -->
          <div class="shop-table-area">
            <el-table v-loading="shopLoading" :data="shopTableData" style="width: 100%"
              @selection-change="handleShopSelectionChange" border>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="shopName" label="商户名称" min-width="200"></el-table-column>
              <el-table-column prop="account" label="电话号码" min-width="150"></el-table-column>
            </el-table>
          </div>
          <!-- 分页区域 -->
          <div class="shop-pagination-area">
            <div class="pagination-info">
              共 {{ shopTotal }} 条
            </div>
            <el-pagination background layout="prev, pager, next, jumper, total" :total="shopTotal"
              :page-size="shopPagination.size" :current-page="shopPagination.page"
              @current-change="handleShopCurrentChange" @size-change="handleShopSizeChange"></el-pagination>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" icon="el-icon-close" @click="shopDialogVisible = false">取消</el-button>
          <el-button type="text" icon="el-icon-check" @click="confirmShopSelection">确定</el-button>
        </span>
      </el-dialog>
      
      <!-- 关联订单员对话框 -->
      <order-associator :visible.sync="bindOrdererDialogVisible" :businessEntityId="currentBusinessEntity ? currentBusinessEntity.id : null"></order-associator>
    </div>
  </basic-container>
</template>
<script>
import { getBusinessEntityList, addBusinessEntity, updateBusinessEntity, deleteBusinessEntity, getShopsList, getBusinessEntityShops, deleteShopEntityBind, addShopEntityBind } from '@/api/salesCloud/businessEntity/businessEntity';
import OrderAssociator from './components/OrderAssociator.vue';
export default {
  name: 'BusinessEntity',
  components: {
    OrderAssociator
  },
  data() {
    return {
      businessEntityId: null,
      // 搜索表单
      searchForm: {
        entityName: '',
        subMerchant: ''
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 总数
      total: 0,
      // 分页参数
      pagination: {
        page: 1,
        size: 10
      },
      // 选中的ID
      selectedIds: [],
      // 对话框
      dialogVisible: false,
      dialogTitle: '',
      // 业务类型可选项（非必填，可多选）
      businessTypeOptions: [
        { label: '净水', value: 'PURE_WATER' },
        { label: '防水', value: 'WATERPROOF' },
        { label: '管道试压', value: 'PIPELINE_TESTING' },
        { label: '售后单', value: 'AFTER_SALES' }
      ],
      // 表单数据
      formData: {
        id: '',
        entityName: '',
        subMerchant: '',
        businessTypes: [],
        shopBindings: []
      },
      // 表单验证规则
      rules: {
        entityName: [
          { required: true, message: '请输入经营主体名称', trigger: 'blur' }
        ]
      },
      // 关联商户弹窗相关
      bindShopDialogVisible: false,
      currentBusinessEntity: null,
      alreadyBoundShops: [],
      // 已关联商户搜索相关
      boundShopSearchKey: '',
      filteredBoundShops: [],
      // 已关联商户分页相关
      boundShopPagination: {
        page: 1,
        size: 10
      },
      boundShopTotal: 0,
      // 商户选择相关
      shopDialogVisible: false,
      shopSearchForm: {
        shopName: '',
        shopMobile: ''
      },
      shopTableData: [],
      shopLoading: false,
      shopTotal: 0,
      shopPagination: {
        page: 1,
        size: 10
      },
      selectedShops: [],
      // 关联订单员弹窗相关
      bindOrdererDialogVisible: false
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.loading = true;
      const params = {
        page: this.pagination.page.toString(),
        size: this.pagination.size.toString(),
        entityName: this.searchForm.entityName,
        subMerchant: this.searchForm.subMerchant
      };
      getBusinessEntityList(params)
        .then(res => {
          this.tableData = JSON.parse(res.data).rows || [];
          this.total = JSON.parse(res.data).total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.pagination.page = 1;
      this.getDataList();
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        entityName: '',
        subMerchant: ''
      };
      this.pagination.page = 1;
      this.getDataList();
    },
    // 分页-当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getDataList();
    },
    // 分页-每页条数变化
    handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.page = 1;
      this.getDataList();
    },
    // 选择项变化
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id);
    },
    // 新增
    handleAdd() {
      this.dialogTitle = '新增经营主体';
      this.formData = {
        id: '',
        entityName: '',
        subMerchant: '',
        businessTypes: [],
        shopBindings: []
      };
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑经营主体';
      this.formData = {
        ...row,
        id: row.id,
        entityName: row.entityName,
        subMerchant: row.subMerchant || '',
        businessTypes: this.parseBusinessTypes(row.businessType),
        shopBindings: []
      };
      this.dialogVisible = true;
      // 加载已关联的商户数据
      // this.loadAlreadyBoundShops(row.id);
    },
    // 业务类型回显：兼容后端返回数组或逗号分隔字符串
    parseBusinessTypes(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return String(val).split(',').filter(Boolean);
    },
    // 打开关联商户弹窗
    handleBindShop(row) {
      this.currentBusinessEntity = row;
      this.bindShopDialogVisible = true;
      this.loadAlreadyBoundShops(row.id);
    },
    // 打开关联订单员弹窗
    handleBindOrderer(row) {
        console.log('index.vue ~ line: 305 ~ row ->', row);
      this.currentBusinessEntity = row;
      this.bindOrdererDialogVisible = true;
    },
    // 加载已关联商户
    loadAlreadyBoundShops(entityId) {
      const params = {
        page: this.boundShopPagination.page.toString(),
        size: this.boundShopPagination.size.toString(),
        shopName: this.boundShopSearchKey
      };
      getBusinessEntityShops(entityId, params)
        .then(res => {
          const data = JSON.parse(res.data);
          const rows = data.rows || [];
          this.alreadyBoundShops = rows;
          this.filteredBoundShops = rows;
          this.boundShopTotal = data.total || 0;
          // 同时加载到formData.shopBindings中，用于编辑时展示
          this.formData.shopBindings = rows;
        })
    },
    // 删除
    handleDelete(id) {
      this.$confirm('确定要删除该经营主体吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteBusinessEntity(id)
            .then(res => {
              if (res.code == 200) {
                this.$message.success('删除成功');
                this.getDataList();
              } else {
                this.$message.error('删除失败');
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    // 批量删除
    handleBatchDelete() {
      this.$confirm(`确定要删除选中的${this.selectedIds.length}个经营主体吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteBusinessEntity(this.selectedIds)
            .then(res => {
              if (res.code == 200) {
                this.$message.success('批量删除成功');
                this.getDataList();
                this.selectedIds = [];
              } else {
                this.$message.error('批量删除失败');
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 准备提交数据，转换shopBindings格式，业务类型多选转为逗号分隔字符串
          const submitData = {
            ...this.formData,
            businessType: (this.formData.businessTypes || []).join(','),
            shopBindings: this.formData.shopBindings.map(shop => ({
              shopId: shop.id,
              shopMobile: shop.account,
              shopName: shop.shopName
            }))
          };
          delete submitData.businessTypes;

          if (this.formData.id) {
            // 编辑
            updateBusinessEntity(submitData)
              .then(res => {
                if (res.code == 200) {
                  this.$message.success('修改成功');
                  this.dialogVisible = false;
                  this.getDataList();
                } else {
                  this.$message.error('修改失败');
                }
              })
          } else {
            // 新增
            addBusinessEntity(submitData)
              .then(res => {
                if (res.code == 200) {
                  this.$message.success('新增成功');
                  this.dialogVisible = false;
                  this.getDataList();
                } else {
                  this.$message.error('新增失败');
                }
              })
          }
        } else {
          return false;
        }
      });
    },
    // 获取商户列表
    getShopList() {
      this.shopLoading = true;
      const params = {
        page: this.shopPagination.page.toString(),
        size: this.shopPagination.size.toString(),
        shopName: this.shopSearchForm.shopName,
        account: this.shopSearchForm.shopMobile,
      };
      // 调用商户列表接口
      getShopsList(params)
        .then(res => {
          const data = JSON.parse(res.data);
          this.shopTableData = data.rows || [];
          this.shopTotal = data.total || 0;
        })
        .finally(() => {
          this.shopLoading = false;
        });
    },
    // 商户搜索
    handleShopSearch() {
      this.shopPagination.page = 1;
      this.getShopList();
    },
    // 重置商户搜索
    resetShopSearch() {
      this.shopSearchForm = {
        shopName: '',
        shopMobile: ''
      };
      this.shopPagination.page = 1;
      this.getShopList();
    },
    // 商户分页-当前页变化
    handleShopCurrentChange(val) {
      this.shopPagination.page = val;
      this.getShopList();
    },
    // 商户分页-每页条数变化
    handleShopSizeChange(val) {
      this.shopPagination.size = val;
      this.shopPagination.page = 1;
      this.getShopList();
    },
    // 商户选择变化
    handleShopSelectionChange(selection) {
      this.selectedShops = selection;
    },
    // 打开商户选择对话框
    openShopDialog() {
      this.shopTableData = [];
      this.shopSearchForm.shopName = '';
      this.shopSearchForm.shopMobile = '';
      this.shopPagination.page = 1;
      this.shopDialogVisible = true;
    },
    // 确认商户选择
    confirmShopSelection() {
      if (this.selectedShops.length > 0) {
        // 将新选的商户添加到formData.shopBindings中
        const params = this.selectedShops;
        const data = params.map(shop => ({
          shopId: shop.id,
          businessEntityId: this.currentBusinessEntity.id,
          shopName: shop.shopName,
          shopMobile: shop.account,
        }));
        // 调用新增关联接口
        addShopEntityBind(data)
          .then(res => {

            if (res.code == '200') {

              this.$message.success('新增关联成功');
              // 刷新已关联列表
              this.loadAlreadyBoundShops(this.currentBusinessEntity.id);
            } else {
              this.$message.error(res.message || '新增关联失败');
            }
          })

      }
      this.shopDialogVisible = false;
      this.selectedShops = [];
    },
    // 已关联商户搜索
    handleBoundShopSearch() {
      this.boundShopPagination.page = 1;
      this.loadAlreadyBoundShops(this.currentBusinessEntity.id);
    },
    // 重置已关联商户搜索
    resetBoundShopSearch() {
      this.boundShopSearchKey = '';
      this.boundShopPagination.page = 1;
      this.loadAlreadyBoundShops(this.currentBusinessEntity.id);
    },
    // 解除单个商户关联
    removeShopBinding(shop) {
      this.$confirm(`确定要解除与商户"${shop.shopName}"的关联吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用解除关联的API
          deleteShopEntityBind({
            id: shop.id
          })
            .then(res => {
              if (res.code == '200') {
                this.$message.success('解除关联成功');
                // 从已关联列表中移除
                this.alreadyBoundShops = this.alreadyBoundShops.filter(item => item.id !== shop.id);
                this.filteredBoundShops = this.filteredBoundShops.filter(item => item.id !== shop.id);
              } else {
                this.$message.error(res.message || '解除关联失败');
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消解除关联');
        });
    },
    // 从表单中移除商户
    removeShopFromForm(shop) {
      this.formData.shopBindings = this.formData.shopBindings.filter(item => item.id !== shop.id);
    },
    // 已关联商户分页-当前页变化
    handleBoundShopCurrentChange(val) {
      this.boundShopPagination.page = val;
      this.loadAlreadyBoundShops(this.currentBusinessEntity.id);
    },
    // 已关联商户分页-每页条数变化
    handleBoundShopSizeChange(val) {
      this.boundShopPagination.size = val;
      this.boundShopPagination.page = 1;
      this.loadAlreadyBoundShops(this.currentBusinessEntity.id);
    }
  }
};
</script>
<style scoped>
.business-entity-container {
  padding: 20px;
  min-height: calc(100vh - 60px);
}

.search-area {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.search-form {
  margin: 0;
}

.action-area {
  background-color: #fff;
  padding: 16px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 12px;
}

.table-area {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.pagination-area {
  background-color: #fff;
  padding: 16px 20px;
  border-radius: 4px;
  margin-top: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-info {
  color: #606266;
  font-size: 14px;
}

.dialog-footer {
  text-align: right;
}

.el-button--text {
  padding: 8px 12px;
  font-size: 14px;
}

.el-button--text:hover {
  background-color: #f5f7fa;
}

.business-entity-dialog .el-dialog__footer {
  padding: 16px 20px;
  border-top: 1px solid #ebeef5;
}

/* 商户绑定样式 */
.shop-bindings-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shop-bindings-container .el-table {
  max-height: 300px;
  overflow-y: auto;
}

.add-shop-btn {
  align-self: flex-start;
}

.no-shops-tip {
  padding: 20px;
  color: #909399;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px dashed #ebeef5;
  border-radius: 4px;
}

/* 关联商户弹窗样式 */
.bind-shop-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.entity-info {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.entity-info h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.entity-desc {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

.already-bound-shops {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shop-search-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shop-search-section h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.search-box {
  display: flex;
  gap: 12px;
  align-items: center;
}

.search-box .el-input {
  flex: 1;
  max-width: 300px;
}

.add-shop-section {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

/* 已关联商户分页样式 */
.bound-shop-pagination-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.bound-shop-pagination-area .pagination-info {
  color: #606266;
  font-size: 14px;
}

/* 商户选择对话框样式 */
.shop-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shop-search-area {
  display: flex;
  gap: 12px;
  align-items: center;
}

.shop-search-area .el-input {
  flex: 1;
  max-width: 300px;
}

.shop-table-area {
  min-height: 300px;
  max-height: 400px;
  overflow-y: auto;
}

.shop-pagination-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
</style>
